export interface BannerLocalizable {
	bannerLocalizableId?: string;
	url?: string;
	firstHeader: string;
	header: string;
	culture: string;
}

export const defaultBannerLocalizableData: BannerLocalizable[] = [
	{
		bannerLocalizableId: "",
		url: "",
		firstHeader: "",
		header: "",
		culture: "tr-TR"
	},
	{
		bannerLocalizableId: "",
		url: "",
		firstHeader: "",
		header: "",
		culture: "en-US"
	}
];

export interface DefaultImageList {
	[key: string]: string;
	imageUrl: string;
	smallImageUrl: string;
}

/* -------------- Operation based interfaces -------------- */

// LIST
export interface BannerListItem {
	bannerId: string;
	isActive: boolean;
	displayOrder?: number;
	hasMenu: boolean;
	headerName: string;
	creationDate: string;
}

export interface BannerListApiResponse {
	result: {
		items: BannerListItem[];
	};
	error: string | null;
	isSuccessful: boolean;
}

// GET
export interface BannerDetail {
	bannerId: string;
	isActive: boolean;
    hasNavigation: boolean;
    imageList: DefaultImageList;
	displayOrder?: number;
	bannerLocalizable: BannerLocalizable[];
}

export interface BannerGetApiResponse {
	result: {
		bannerId: string;
		isActive: boolean;
        hasNavigation: boolean;
		imageUrl: string;
		smallImageUrl: string;
		displayOrder?: number;
		bannerLocalizable: BannerLocalizable[];
	}
	error: string | null;
	isSuccessful: boolean;
}

// ORDER
export interface BannerOrderItem {
	bannerId: string;
	displayOrder?: number;
}

// ADD/UPDATE
export interface BannerFormData {
	bannerId?: string;
	isActive: boolean | undefined;
	hasNavigation: boolean | undefined;
    images: {
        image: File | null;
		smallImage: File | null;
	}
	bannerLocalizable: BannerLocalizable[];
}

export const defaultBannerFormData: BannerFormData = {
	bannerId: "",
	isActive: undefined,
	hasNavigation: undefined,
	images: {
		image: null,
		smallImage: null,
	},
	bannerLocalizable: defaultBannerLocalizableData
};

// Page States
export type OperationStatus =
	| { type: "idle" }
	| { type: "loading"; operation: "add" | "fetch" | "update" | "delete" }
	| { type: "error"; operation: string; message: string };

